module.exports = __webpack_public_path__ + "static/media/icon-scheduling-map.bad0a7a3.svg";